export default "__VITE_ASSET__Cn6Th4Tr__"